import { Component, DestroyRef, HostListener, inject, OnInit, signal, TemplateRef, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import 'jspdf-autotable';
import { Router } from '@angular/router';
import { CountableTimeZonePipe } from 'countable@helpers';
import { SPIN_STYLES, SpinInputModel, UserDetailModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { AclModel } from '../../../model/acl.model';
import { ExportModel } from '../../../model/export.model';
import { AclService } from '../../../services/acl.service';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../services/auth.service';
import { EngApiService } from '../../../services/eng-api.service';
import { TbApiService } from '../../../services/tb-api.service';
import { SharedService } from '../../shared/shared.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-daily-loads',
  templateUrl: './daily-loads.component.html',
  styleUrls: ['./daily-loads.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DailyLoadsComponent implements OnInit {

  @ViewChild('rejectDialog') rejectDialog: TemplateRef<any>;
  @ViewChild('acceptDialog') acceptDialog: TemplateRef<any>;
  @ViewChild('balanceDialogBox') balanceDialogBox: TemplateRef<any>;
  loggedInUserData: UserDetailModel;
  useraccountid: any;
  dailyLoadData: any;
  engagementID: string;
  trialbalanceData: any = [];
  datesData: any = [];
  trialBalYear: any;
  recentStatus: any;
  selectedEngagementDataCopy: any;
  engagementName: any;
  clientName: any;
  yearEnd: any;
  originaltotal: any;
  revisedtotal: any;
  changetotal: any;
  removeBarcketsPattern = /[(),]/g;
  selectedEntityName: any;
  selectedYear: any;
  dailyLoadChangesStatu: any;
  trailBalanceDetailsCopy: any;
  balReconciledTitle = 'Trial Balance not Reconciled';
  lasupdatedate: any;
  isTblFooter: boolean = false;
  shortCutMenuDetailsObj: any;
  accessPermissions: AclModel;
  loadData: any;
  filteredEmail: any = [];
  private destroyRef = inject(DestroyRef);
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null, SPIN_STYLES.BLUR_WITH_SPIN, false));
  private spinCount: number = 0;

  @HostListener('window:storage', ['$event'])
  onStorageChange(ev: StorageEvent) {
    if (ev.key == 'dailyLoadChangesLoaded') {
      this.trailBalanceDetailsCopy = JSON.parse((localStorage.getItem('trialBalanceObj')));
    }
  }

  constructor(private authService: AuthService, private aclService: AclService, public router: Router, public dialog: MatDialog,
              private apiservice: ApiService, private sharedService: SharedService, private toastr: ToastrService,
              private countableTimeZonePipe: CountableTimeZonePipe,
              private tbApiService: TbApiService, private engApiService: EngApiService) { }

  ngOnInit() {
    this.authService.subjectUserDetail.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(detail => {
      this.loggedInUserData = detail;
      this.useraccountid = detail.useracctid;
    });
    this.aclService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(acl => {
      this.accessPermissions = acl;
    });
    this.shortCutMenuDetailsObj = JSON.parse((localStorage.getItem('shortCutMenuDetails')));
    this.selectedEngagementDataCopy = JSON.parse((localStorage.getItem('selectedEngagementObjCopy')));
    this.engagementName = this.selectedEngagementDataCopy.engagementName
    this.clientName = this.selectedEngagementDataCopy.clientName
    this.yearEnd = this.selectedEngagementDataCopy.yearEnd
    this.engagementID = localStorage.getItem('engagementID');
    this.trialBalYear = localStorage.getItem('trailBalYear');
    this.getDailyLoadData()
    this.selectedEntityName = this.selectedEngagementDataCopy.clientName;
    this.selectedYear = this.countableTimeZonePipe.transform(this.selectedEngagementDataCopy.yearEnd, 'MMM dd, yyyy', 'UTC');
  }

  displayedColumns: string[] = ['account', 'description', 'leadsheet'];

  displayedColumns1: string[] = ['original', 'revised', 'change'];

  getDailyLoadData() {
    let inputData = { "engagementid": this.engagementID, "acctyear": this.trialBalYear }
    let inputString = JSON.stringify(inputData);
    this.isTblFooter = this.isTblFooter ? false : false;
    this.updateSpinnerConfig(true);
    this.engApiService.getTbDailyLoadFromUi(inputString).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          let data = JSON.parse(res?.data);
          if (data) {
            this.trailBalanceDetailsCopy = JSON.parse((localStorage.getItem('trialBalanceObj')));

            if (this.router.url === '/dailyload-details') {
              this.dailyLoadChangesStatu = +this.shortCutMenuDetailsObj.tdlchanges;
            } else {
              this.dailyLoadChangesStatu = +this.trailBalanceDetailsCopy[0].tdlchanges;
            }

            localStorage.removeItem('dailyLoadChangesLoaded');
            this.dailyLoadData = data[0];
            this.trialbalanceData = this.dailyLoadData.trialbalance;
            this.datesData = this.dailyLoadData.datewisedata;
            this.recentStatus = this.datesData[0].auditorstatus;
            this.lasupdatedate = this.countableTimeZonePipe.transform(this.dailyLoadData?.lasupdatedate[0]?.lasupdatedate);
            if (this.datesData[0].originaltotal) {
              var totalOriginal = this.datesData[0].originaltotal.replace(this.removeBarcketsPattern, '');
            }
            if (this.datesData[0].revisedtotal) {
              var totalRevised = this.datesData[0].revisedtotal.replace(this.removeBarcketsPattern, '');
            }
            if (this.datesData[0].chngtotal) {
              var totalChange = this.datesData[0].chngtotal.replace(this.removeBarcketsPattern, '');
            }

            this.originaltotal = +totalOriginal ? totalOriginal : 0;
            this.revisedtotal = +totalRevised ? totalRevised : 0;
            this.changetotal = +totalChange ? totalChange : 0;

            if (this.dailyLoadChangesStatu === 1) {
              if (this.recentStatus == 1 && this.revisedtotal != 0) {
                this.balanceDialog();
              }
            }
          }
          this.isTblFooter = true;
        }
      }, error: e => {
        this.toastr.warning(e.error);
      }
    })
  }

  rejectDialogOpen() {
    const dialogRef = this.dialog.open(this.rejectDialog, {});
    dialogRef.afterClosed().subscribe(result => { });
  }

  saveResponse(status) {
    let dbrecieveddate;
    if (this.datesData && this.datesData.length > 0) {
      dbrecieveddate = this.datesData[0].dbrecieveddate;
    }
    this.updateSpinnerConfig(true);
    this.tbApiService.updateTbAuditorStatus(this.engagementID ? Number(this.engagementID) : 0,
      status, dbrecieveddate).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: response => {
        if (response.status === 200) {
          this.loadData = JSON.parse(response.data);
          this.loadData.filter((ele) => {
            if (ele.name) {
              this.filteredEmail.push({id: ele.name});
            }
          });
          localStorage.setItem('dailyLoadChangesLoaded', 'success');
          if (status === 5) { //Accept
            this.dailyLoadChangesStatu = 5;
            this.toastr.success('Trial Balance Changes have been accepted');
            localStorage.setItem('TBChangeAccepted-ES', 'success');
          } else if (status === 6) { //Reject
            this.dailyLoadChangesStatu = 6;
            this.toastr.success('Trial Balance changes have been rejected');
          }

          if (this.router.url != '/dailyload-details') {
            this.router.navigate(['/dashboard/ntrdashboard/TrialBalance']);
            this.sharedService.refreshShortCutButtons.next(true);
          } else {
            localStorage.setItem('tbchangesaction', 'success');
            setTimeout(() => {
              window.opener = self;
              window.close();
            }, 1000);
          }
        }
      }, error: e => {
        this.toastr.error('Error in saving');
      }
    });
  }

  viewTrialBalance() {
    this.router.navigate(['/dashboard/ntrdashboard/TrialBalance']);
  }

  balanceDialog(): void {
    this.dialog.open(this.balanceDialogBox).afterClosed().subscribe();
  }

  exportTBCheckPdf() {
    const Obj : ExportModel = new ExportModel();
    Obj.id = +this.engagementID;
    Obj.year = this.trialBalYear;
    const fileName = 'TrailbalanceDailyLoad.Pdf';
    this.updateSpinnerConfig(true);
    this.sharedService.exportService.exportTBCheck(Obj,fileName).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: response => {
        if(response){
          this.toastr.success('Download Successfully');
        } else {
          this.toastr.error('Download Failed')
        }
      },
      error: error => {
        console.log('Error',error);
      }
    });
  }

  private updateSpinnerConfig(value: boolean) {
      value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
      this.spinnerConfig.update((config) => ({ ...config, isSpinShown: this.spinCount > 0 }));
     }
}
